import { Group } from "@mantine/core"
import { useEffect, useState } from "react"
import z from "zod"

import { Select } from "../../Inputs/Select/Select"

import { DateFilterDto, DateFilterOperator } from "./date-filter.types"
import {
  DateFilterValueComponentFactory,
  useDateFilterValueComponentFactory,
} from "./hooks/useDateFilterValueComponentFactory"
import { useOperatorsSelectItems } from "./hooks/useOperatorsSelectItems"

export type DateFilterProps = {
  key: string
  onChange: (filter: DateFilterDto) => void
  locale?: string
  value: DateFilterDto | null
  labelTranslationResolver: Record<DateFilterOperator, string>
}

export const DateFilter = ({
  onChange,
  locale,
  value,
  labelTranslationResolver,
}: DateFilterProps) => {
  const [operator, setOperator] = useState<DateFilterOperator>(
    value?.operator ?? DateFilterOperator.between
  )
  const {
    getComponentForOperator,
    dateRange,
  }: DateFilterValueComponentFactory = useDateFilterValueComponentFactory({
    value,
    locale,
  })

  const operatorSelectItems = useOperatorsSelectItems(labelTranslationResolver)

  useEffect(() => {
    const [startDate, endDate] = dateRange

    onChange({ operator, startDate, endDate })
  }, [dateRange, operator, onChange])

  return (
    <Group>
      <Select
        data={operatorSelectItems}
        value={operator}
        onChange={(value) =>
          setOperator(z.enum(DateFilterOperator).parse(value))
        }
        w="8rem"
      />
      {getComponentForOperator(operator)}
    </Group>
  )
}
